import React from "react";

export function lazyRoute(element: React.ReactNode) {
  return <React.Suspense fallback={<Loader />}>{element}</React.Suspense>;
}

function Loader() {
  return <>{/** TODO: ADD LOADER */}</>;
}
